import React from 'react';
window.React = React;
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from 'shell/store';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';
import './index.scss';
import App from './app/App';

// Append wogaa.js script before render
const script = document.createElement('script');
script.setAttribute(
  'src',
  process.env.REACT_APP_WOGAA_ANALYTICS_SCRIPT as string,
);
document.head.append(script);

// Append site search script before render
const siteSearchScript = document.createElement('script');
const siteSearchClientId = process.env
  .REACT_APP_SITE_SEARCH_CLIENT_ID as string;
siteSearchScript.setAttribute('id', 'searchsg-config');
siteSearchScript.setAttribute(
  'src',
  `https://api.search.gov.sg/v1/searchconfig.js?clientId=${siteSearchClientId}`,
);
siteSearchScript.setAttribute('defer', '');
document.head.append(siteSearchScript);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <BrowserRouter basename={process.env.REACT_APP_BROWSER_ROUTER_BASENAME}>
        <StoreProvider>
          <App />
        </StoreProvider>
      </BrowserRouter>
    </CookiesProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
